import React from "react";
import './styles.404.css'

const NotFound = () => {
    return(
        <div className="not-found">404 || NOT FOUND</div>
    )
}

export default NotFound;